import { render, staticRenderFns } from "./ConsentLetter.vue?vue&type=template&id=823037de&scoped=true"
import script from "./ConsentLetter.vue?vue&type=script&lang=js"
export * from "./ConsentLetter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823037de",
  null
  
)

export default component.exports